import React from 'react';
import {Box, Button, Container, Grid, Typography} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';
import {Link} from 'react-router-dom';

const useStyles = makeStyles(theme => ({
    root: {
        paddingTop: '4rem',
    },
}));

const WelcomeSeaServiceMessage = () => {
    const classes = useStyles();

    return (
        <Container maxWidth='xs'>
            <Grid container justifyContent='center' className={classes.root}>
                <Grid item sm>
                    <Box textAlign='center'>
                        <Typography variant='h6' display='inline'>
                            <Box fontWeight='bold' component='span'>
                                Welcome!
                            </Box>{' '}
                            You're going to add one sea service document at a
                            time. Click the Add button to get started!
                        </Typography>
                        <Box padding='1rem'>
                            <Button
                                component={Link}
                                to='/adddocs'
                                variant='contained'
                                color='secondary'
                            >
                                + Add
                            </Button>
                        </Box>
                        <Typography variant='h6'>
                            Once you've added some sea service, return to this
                            page to see your progress!
                        </Typography>
                    </Box>
                </Grid>
            </Grid>
        </Container>
    );
};

export default WelcomeSeaServiceMessage;
